export default "__VITE_ASSET__Cugo4g38__"